module.exports = __webpack_public_path__ + "media/assets/images/shopping/question-mark-bc561791204497a9cc99ff1a33eb6e5e.svg";